goog.provide('el8.apphome.reqAct.main');

goog.require('el8.apphome.reqAct.providerLetters');
goog.require('el8.apphome.reqAct.patientLetters');
goog.require('el8.apphome.reqAct.emails');
goog.require('el8.apphome.reqAct.rxRequests');
goog.require('el8.apphome.reqAct.messages');
goog.require('el8.apphome.reqAct.reports');
goog.require('el8.apphome.reqAct.unfinishedNotes');
goog.require('el8.apphome.reqAct.unfinishedLetters');
goog.require('el8.apphome.reqAct.reminders');

goog.require('el8.apphome.reqAct.unfinishedOrders');
goog.require('el8.apphome.reqAct.urgents');
goog.require('el8.appservice.notifier');
goog.require('el8.data.practiceUsers');
goog.require('el8.util.dom');
goog.require('el8.util.localStorage');
goog.require('el8.util.string');
goog.require('el8.util.perfMark');


el8.apphome.reqAct.main = (function() {

    var DEFAULT_TAB = (el8Globals.PASSPORT_EMR) ? 'providerLetters' : 'urgents';
    return {
        init: function() {

            $('#home-feed-contents').append(
                el8.template.render.reqAct.contents()
            );

            var that = this;
            this._tabbedNav = new el8.uiwidget.TabbedNav();
            this._tabbedNav.init({
                wrapper: $('#req-act-tabs'),
                tabSectionClass: 'el8VerticalTabSection'
            });

            // queues that will start a new "section" under an hrule in the nav
            var sectionHeaders = [];

            var section1 = ['urgents'];
            var section2 = ['messages', 'rxRequests', 'reports'];
            sectionHeaders.push(section2[0]);

            // Third Section - Closing the loop, letters and orders
            var section3 = [];
            section3.push('reminders');
            if (el8Globals.FEATURES['PatientPortal']) {
                section3.push('patientLetters');
            }
            if (el8Globals.FEATURES['Letters']) {
                section3.push('providerLetters');
            }
            if (el8Globals.FEATURES['EmailImport']) {
                section3.push('emails');
            }
            sectionHeaders.push(section3[0]);

            // Last Section -- Unfinished/Unsigned Chart Documentation
            var section4 = [];
            section4.push('unfinishedNotes');

            if (el8Globals.FEATURES['Letters']) {
                section4.push('unfinishedLetters');
            }
            section4.push('unfinishedOrders');
            sectionHeaders.push(section4[0]);

            this._tabNames = section1.concat(section2).concat(section3).concat(section4);
            this._initQueueTypeSelector();

            el8.util.perfMark.start("Scenario:ReqAct:UpdateCount");

            // We're going to show DEFAULT_TAB as soon as it returns, regardless of whether it has
            // results, so the user can see something render. Then, after all the indexes have loaded,
            // we'll switch to the first tab with results in it
            var tabCheckinFn = _.after(that._tabNames.length, function() {
                el8.util.perfMark.stop("Scenario:ReqAct:UpdateCount");
                that._showFirstNonEmptyTab();
             });

            this._tabNames.forEach(function(tab) {
                el8.apphome.reqAct[tab].init({
                    tabbedNav: that._tabbedNav,
                    isSectionHeader: $.inArray(tab, sectionHeaders) > -1,
                    queueContainer: $('#req-act-contents'),
                    queueType: that._getSelectedQueueType(),
                    callbackFn: function() {
                        // we may eventually switch from this tab but we want something to render
                        // quickly, in case one tab/feed happens to just be really slow
                        if (tab === DEFAULT_TAB) {
                            that._tabbedNav.showTab(tab);
                        }
                        tabCheckinFn();
                    },
                    sortUpdatedFn: function(isNewestFirst) {
                        el8.util.localStorage.setItem('practiceHomeSortNewestFirst', isNewestFirst);
                        that.setQueueSortOrder(isNewestFirst);
                    }
                });
            });

            var $patientFeedContainer = $('#patient-feed-container');
            this._hover = new el8.uiwidget.Hover({
                holder: $('.req-act-hover-holder', $patientFeedContainer),
                hoverSection: $('.req-act-hover-section', $patientFeedContainer),
                scrollContainer: $patientFeedContainer
            }).start();


            $(document).on('click', '#refresh-req-act-trigger',  function(e) {
                var $btn = $(this);
                // Do nothing if disabled
                if ($btn.prop('disabled')) { return; }
                el8.appservice.notifier.notify(
                      'Refreshing patients requiring action...');

                $btn.prop('disabled', true);
                el8.appservice.notifier.notify(
                    'Refreshing patients requiring action...');

                that.refreshAllQueues(true, function() {
                    $btn.prop('disabled', false);
                    el8.appservice.notifier.notify(
                        'Patients requiring action refreshed.');
                });
            });

            $(document).on('click', '.sort-req-act-newest-first-trigger',  function(e) {
                for (var i=0; i<that._tabNames.length; i++) {
                    el8.apphome.reqAct[that._tabNames[i]].setSortOrder(true);
                }

                el8.appservice.notifier.notify(
                    'Refreshing patients requiring action...');
                that.refreshAllQueues(true, function() {
                    el8.appservice.notifier.notify(
                        'Patients requiring action refreshed.');
                });
            });

            $(document).on('change', '#req-act-queue-types',  function(e) {
                var selectedQueueType = $(this).val();
                var showingTab = that._tabbedNav.getShowingTab();
                if (showingTab) {
                    // showingTab might be null if the queue type is changed quickly during page load
                    el8.apphome.reqAct[showingTab].updateQueueType(selectedQueueType, true);
                }

                for (var i=0; i<that._tabNames.length; i++) {
                    if (that._tabNames[i] !== showingTab) {
                        el8.apphome.reqAct[that._tabNames[i]].updateQueueType(selectedQueueType);
                    }
                }
            });

            $(document).on('click', '.launch-req-act-trigger',  function(e) {
                var feedName = $(this).attr('data-name');
                var blockSize = parseInt($(this).attr('data-count'), 10);
                that.launchXReqAct(feedName, blockSize, $(this));
            });
        },

        setQueueSortOrder: function(is_newest_first) {
            var that = this;
            for (var i=0; i<that._tabNames.length; i++) {
                el8.apphome.reqAct[that._tabNames[i]].setSortOrder(is_newest_first);
            }

            el8.appservice.notifier.notify(
                'Refreshing patients requiring action...');
            that.refreshAllQueues(true, function() {
                el8.appservice.notifier.notify(
                    'Patients requiring action refreshed.');
            });
        },

        refreshAllQueues: function(force, completeCallbackFn) {
            var that = this;

            // completeCallbackFn will run after callbackFn is called that._tabNames.length times */
            var callbackFn = null;
            if (completeCallbackFn) { callbackFn = _.after(that._tabNames.length, completeCallbackFn); }

            // Do refresh all queues
            var showingTab = that._tabbedNav.getShowingTab();
            el8.apphome.reqAct[showingTab].refresh({
                isShowing: true,
                async: true,
                force: force,
                callbackFn: callbackFn
            });
            for (var i=0; i<that._tabNames.length; i++) {
                if (that._tabNames[i] !== showingTab) {
                    el8.apphome.reqAct[that._tabNames[i]].refresh({
                        isShowing: false,
                        async: true,
                        callbackFn: callbackFn
                    });
                }
            }
        },

        launchXReqAct: function(feedName, blockSize, trigger) {

            el8.appservice.notifier.notify('First, refreshing...');
            el8.apphome.reqAct[feedName].refresh({
                isShowing: true,
                async: false
            });
            el8.appservice.notifier.notify('Refreshed.');

            var feed = el8.apphome.reqAct[feedName].getFeed();

            // If feed is empty, do nothing
            if (feed && feed.isEmpty()) {
                el8.appservice.notifier.notify('No patients requiring actions to launch.');
            }

            // Go through the first blockSize items and launch chart
            var feedItemIds = feed.getReqActPatientIds(blockSize);
            for (var i=0; i<feedItemIds.length; i++) {
                var url = '/patient/'+feedItemIds[i]+'/req-action/';
                el8.util.dom.openBackgroundTab(url);
            }

            // Disable button for 2 seconds
            trigger.prop('disabled', true);
            $.el8_setTimeout(function() {
                trigger.prop('disabled', false);
            }, 2000);

        },

        _initQueueTypeSelector: function() {
            var $select = $('#req-act-queue-types');
            // if the user is using passport, show them the "Everyone" queue by default
            var list = [{name: 'Self', value: el8.data.currUser.getId(), selected: (!el8Globals.PASSPORT_EMR)}];
            var names = el8Globals.FEATURES.WorkspaceAwareRAQ && el8.util.workspace.isInEffect() ?
            ["Entire Workspace","Workspace Physicians","Workspace Staff"]
            : ["Everyone","All Physicians", "All Staff"]
            list.addArray([
                {name: names[0], value: 'all', selected: (el8Globals.PASSPORT_EMR || el8Globals.ONBOARDING) },
                {name: names[1], value: 'physicians'},
                {name: names[2], value: 'staff'}
            ]);
            // First add all physicians
            var physicianList =
                el8.data.practiceUsers.allInWorkspaceExcept(el8.data.currUser.getId())
                    .filter(function(u) {
                        return u.isPhysician();
                    })
                    .sort(function(u1, u2) { return el8.util.string.cmp(u1.getFullName(), u2.getFullName()); })
                    .map(function(u) {
                        return {
                            name: u.getFullName(),
                            value: u.getId()
                        };
                    });
            // Then add all staff
            var staffList =
                el8.data.practiceUsers.allInWorkspaceExcept(el8.data.currUser.getId())
                    .filter(function(u) {
                        return u.isOfficeStaff();
                    })
                    .sort(function(u1, u2) { return el8.util.string.cmp(u1.getFullName(), u2.getFullName()); })
                    .map(function(u) {
                        return {
                            name: u.getFullName(),
                            value: u.getId()
                        };
                    });
            $select.html(
                el8.template.render.reqAct.queueList({
                    list: list,
                    physicianList: physicianList,
                    staffList: staffList
                })
            );

        },

        _getSelectedQueueType: function() {
            return $('#req-act-queue-types').val();
        },

        _showFirstNonEmptyTab: function() {
            // the order in tabNames corresponds to the order in the UI, so we pick the first one with results
            for (var i=0; i < this._tabNames.length; i++) {
                var tab = this._tabNames[i];
                if (el8.apphome.reqAct[tab].getFeed().getIndexSize()) {
                    // if tab == DEFAULT_TAB, we already showed it
                    if (tab !== DEFAULT_TAB) {
                        this._tabbedNav.showTab(tab);
                    }
                    return;
                }
            }
        }

    };

})();
